import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    style={{ willChange: "opacity, transform" }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const StaggerGroup = ({ children, className = "", stagger = 0.12 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: stagger } },
    }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 40 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal used in the hero
export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: [0.76, 0, 0.24, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

// Decorative crosshair corners
export const Corners = ({ className = "" }) => (
  <>
    <span className={`pointer-events-none absolute -top-px -left-px h-3 w-3 border-t border-l border-fluor/60 ${className}`} />
    <span className={`pointer-events-none absolute -top-px -right-px h-3 w-3 border-t border-r border-fluor/60 ${className}`} />
    <span className={`pointer-events-none absolute -bottom-px -left-px h-3 w-3 border-b border-l border-fluor/60 ${className}`} />
    <span className={`pointer-events-none absolute -bottom-px -right-px h-3 w-3 border-b border-r border-fluor/60 ${className}`} />
  </>
);
